import React from 'react';
import styles from './index.scss';
import PopUp from './PopUp';
import { classCodeCss } from './utils';

const ProductScore = (props) => {
	const { finalWeight } = props;
	const { scoreColorCode, scoreSchmeClass } = classCodeCss(finalWeight);

	return (
		<div className={`${styles['product-score-tag']}${' ' + styles[scoreSchmeClass]} ${+props.finalWeight === 100 && props.isServiceScore === false ? styles['pd-100'] : ''}`}>
			<div className={styles['inside-product-scroe-tag']}>
				<div className={styles['product-score-icon']}>
					<svg className={`${styles['icon-placement']}${' ' + styles['icon-placement-mb']}`} viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M7.83902 6.4478C8.05801 6.57296 8.3393 6.49513 8.43794 6.26299C8.68187 5.6889 8.80582 5.06749 8.79978 4.43856C8.79226 3.65568 8.58359 2.88847 8.19454 2.21328C7.8055 1.5381 7.24964 0.978496 6.58231 0.590185C5.91498 0.201874 5.15945 -0.00160304 4.39093 9.51048e-06C3.62241 0.00162206 2.86771 0.208268 2.20196 0.599376C1.5362 0.990484 0.982615 1.55241 0.596301 2.22922C0.209988 2.90604 0.00442291 3.67412 7.05789e-05 4.45702C-0.00342571 5.08594 0.123021 5.7068 0.369245 6.27983C0.468832 6.5116 0.750484 6.58828 0.968977 6.4622V6.4622C1.18261 6.33893 1.2549 6.06785 1.16255 5.83915C0.986755 5.4038 0.896744 4.93588 0.899377 4.46221C0.90284 3.83933 1.06639 3.22823 1.37374 2.68976C1.6811 2.15128 2.12154 1.7042 2.65122 1.39303C3.1809 1.08187 3.78134 0.917456 4.39278 0.916173C5.00422 0.91489 5.60533 1.07678 6.13626 1.38572C6.6672 1.69467 7.10944 2.13989 7.41897 2.67707C7.7285 3.21425 7.89452 3.82466 7.9005 4.44752C7.90505 4.92118 7.81693 5.38949 7.64289 5.82557C7.55147 6.05464 7.62488 6.32542 7.83902 6.4478V6.4478Z" fill={scoreColorCode} />
						<circle cx="4.11068" cy="5.20684" r="0.822136" fill={scoreColorCode} />
						<path d="M4.2203 4.93268L5.89301 2.45151" stroke={scoreColorCode} stroke-width="0.5" stroke-linecap="round" />
					</svg>
				</div>
				<PopUp {...props} />
			</div>
		</div>
	);
};

export default ProductScore;
